import { render, staticRenderFns } from "./DdDropDown.vue?vue&type=template&id=83e8c68c&scoped=true&"
import script from "./DdDropDown.vue?vue&type=script&lang=js&"
export * from "./DdDropDown.vue?vue&type=script&lang=js&"
import style0 from "./DdDropDown.vue?vue&type=style&index=0&id=83e8c68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e8c68c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSelect,VTooltip})
